export const RECLAIM_WALKTHROUGH_TASK_ID = "take-reclaim-walkthrough";
export const ENABLE_AI_AUTOMATION_TASK_ID = "enable-ai-automation";
export const EXPLORE_RECLAIM_INTEGRATIONS_TASK_ID =
  "explore-reclaim-integrations";
